import { render, staticRenderFns } from "./FilaConsultasProvisorias.vue?vue&type=template&id=65da0288&"
import script from "./FilaConsultasProvisorias.vue?vue&type=script&lang=js&"
export * from "./FilaConsultasProvisorias.vue?vue&type=script&lang=js&"
import style0 from "./FilaConsultasProvisorias.vue?vue&type=style&index=0&id=65da0288&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports